/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "components/DatePicker";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import Button from "components/Button";
import {
  imsRetailOrderUpdateOrder,
  cancelOrder,
  submitOrderToCanada,
  submitOrderToUSA,
  imsRetailOrderEvents,
  getTrackingUSNumber,
  addNotes,
} from "actions/orders";
import {
  Row,
  SubRow,
  RowHeader,
  RowFooter,
  ModalWrapper,
  ModalBody,
  ModalBody1,
  ModalTitle,
  SubmitButton,
} from "styles/pages/smart-print-sink";

const regExpr = /[^a-zA-Z0-9- ]/g;

const OrbitkitModal = ({ onClose, open, data }) => {
  const token = useSelector((state) => state?.auth?.profile?.token);
  const dispatch = useDispatch();
  const [events, setEvents] = useState(null);
  const [expectedShipDate, setShipDate] = useState(moment());
  const [notes, setNotes] = useState(undefined);
  const [trackingInfo, setTrackingInfo] = useState(null);

  useEffect(() => {
    (async () => {
      if (data?.cart?.header[0]?.sessionid[0] && !events) {
        const response = await dispatch(
          imsRetailOrderEvents({
            id: data?.cart?.header[0]?.sessionid[0],
          })
        );

        const t = await dispatch(
          getTrackingUSNumber({
            orderId: `${Number(data?.cart?.header[0]?.sessionid[0])}`,
          })
        );

        setTrackingInfo(t);
        setEvents(response);
      }
    })();
  }, [data?.cart?.header[0]?.sessionid[0], dispatch]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle style={{ position: "relative" }}>
        <h2 style={{ margin: 0, borderBottom: "1px solid black" }}>
          {data?.cart?.header[0]?.sessionid[0]}
        </h2>
        <CloseIcon
          style={{ position: "absolute", right: 10, top: 10 }}
          onClick={onClose}
        />
      </DialogTitle>
      <DialogContent style={{ paddingTop: 0 }}>
        <ModalWrapper>
          <ModalBody>
            {data?.cart?.item.map((d, index) => {
              return (
                <Row key={index}>
                  <RowHeader>
                    <span>SKU:{d?.productname[0]}</span>
                    <span>Size:{d?.customfield1[0]?.value[0]}</span>
                    <span>Color:{d?.color[0]}</span>
                  </RowHeader>

                  <RowHeader>
                    {!!d?.customfield1[0]?.value[0] && (
                      <span>
                        {d?.customfield1[0]?.name[0]}:
                        {d?.customfield1[0]?.value[0]}
                      </span>
                    )}

                    {!!d?.customfield2[0]?.value[0] && (
                      <span>
                        {d?.customfield2[0]?.name[0]}:
                        {d?.customfield2[0]?.value[0]}
                      </span>
                    )}

                    {!!d?.customfield3[0]?.value[0] && (
                      <span>
                        {d?.customfield3[0]?.name[0]}:
                        {d?.customfield3[0]?.value[0]}
                      </span>
                    )}

                    {!!d?.customfield4[0]?.value[0] && (
                      <span>
                        {d?.customfield4[0]?.name[0]}:
                        {d?.customfield4[0]?.value[0]}
                      </span>
                    )}
                  </RowHeader>

                  <RowHeader
                    style={{
                      border: "1px dashed black",
                      padding: "2px",
                      borderRadius: "2px",
                    }}
                  >
                    Quantity: {d?.qty[0]}
                  </RowHeader>

                  <RowHeader
                    style={{
                      border: "1px dashed black",
                      padding: "2px",
                      borderRadius: "2px",
                    }}
                  >
                    SPC: {d?.spc[0]}
                  </RowHeader>

                  <RowHeader
                    style={{
                      border: "1px dashed black",
                      padding: "2px",
                      borderRadius: "2px",
                    }}
                  >
                    Supply Item: {d?.suppitemnum[0]}
                  </RowHeader>

                  <SubRow>
                    <img src={d?.quickpicthumblink[0]} alt="thumb" />
                    <div className="src">
                      <img src={d?.imprintlogoartfile[0]} alt="src" />
                    </div>
                  </SubRow>
                </Row>
              );
            })}

            <RowHeader>
              {data?.cart?.header[0]?.shippinginfo[0]?.name[0]}&nbsp;
              <br />
              {data?.cart?.header[0]?.shippinginfo[0]?.address[0]}
              {data?.cart?.header[0]?.shippinginfo[0]?.address2[0]}&nbsp;
              <br />
              {data?.cart?.header[0]?.shippinginfo[0]?.city[0]}&nbsp;
              {data?.cart?.header[0]?.shippinginfo[0]?.state[0]}&nbsp;
              {data?.cart?.header[0]?.shippinginfo[0]?.country[0]}&nbsp;
              {data?.cart?.header[0]?.shippinginfo[0]?.zip[0]}
            </RowHeader>

            <Stepper alternativeLabel activeStep={events?.length}>
              {events?.map((e) => (
                <Step key={e?.action}>
                  <StepLabel>
                    {e?.action?.toUpperCase()}
                    <br />
                    {moment(e?.time).format("MMM DD,YYYY")}
                    <br />
                    {e?.action === "shipped" &&
                      trackingInfo?.shipments?.map((t) => (
                        <div
                          style={{
                            background: "green",
                            color: "white",
                            padding: 5,
                            marginBottom: 5,
                            borderRadius: 5,
                          }}
                        >
                          {t?.trackingNumber}
                        </div>
                      ))}
                    {/* {e?.tracking?.trackingNumber || ''} */}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>

            <RowFooter>
              {data?.Status !== "Declined" && data?.Status !== "Shipped" && (
                <Button
                  className="declined"
                  title="Decline"
                  onClick={async () => {
                    const payload = {
                      OrderNumber: data?.cart?.header[0]?.sessionid[0],
                      Status: "Declined",
                      Event: {
                        action: "declined",
                        time: moment().format("YYYY-MM-DD"),
                      },
                    };
                    await dispatch(imsRetailOrderUpdateOrder(payload));
                    await dispatch(
                      cancelOrder({
                        printProvider: "US",
                        source: "Admin",
                        orderId: `FICO-${data?.cart?.header[0]?.sessionid[0]}`,
                      })
                    );
                    onClose();
                  }}
                />
              )}
              {data?.Status !== "Approved" &&
                data?.Status !== "Processed" &&
                data?.Status !== "Shipped" && (
                  <Button
                    title="Approve"
                    className="approve"
                    onClick={async () => {
                      const payload = {
                        OrderNumber: data?.cart?.header[0]?.sessionid[0],
                        Status: "Approved",
                        Event: {
                          action: "approved",
                          time: moment().format("YYYY-MM-DD"),
                        },
                      };
                      await dispatch(imsRetailOrderUpdateOrder(payload));

                      await dispatch(
                        imsRetailOrderUpdateOrder({
                          OrderNumber: data?.cart?.header[0]?.sessionid[0],
                          Status: "Processed",
                          Event: {
                            action: "processed",
                            time: moment().format("YYYY-MM-DD"),
                          },
                        })
                      );

                      const shippingCountry =
                        data?.cart?.header[0]?.shippinginfo[0]?.country[0];
                      const orderId = data?.cart?.header[0]?.sessionid[0];

                      let items = "";

                      for (let i = 0; i < data?.cart?.item.length; i++) {
                        const orderLineItem = data?.cart?.item[i];

                        items += `<Item>
                    <SKU>[${
                      orderLineItem?.suppitemnum[0]
                    }] ${orderLineItem?.productname[0].replace(
                          regExpr,
                          ""
                        )}</SKU>
                    <Descrip>[EMB][SKU:${orderLineItem?.suppitemnum[0]?.replace(
                      regExpr,
                      ""
                    )} | SPC:${orderLineItem?.spc[0]?.replace(
                          regExpr,
                          ""
                        )}][${orderLineItem?.customfield1[0]?.value[0]?.replace(
                          regExpr,
                          ""
                        )} / ${orderLineItem?.customfield2[0]?.value[0]?.replace(
                          regExpr,
                          ""
                        )} / ${orderLineItem?.customfield3[0]?.value[0]?.replace(
                          regExpr,
                          ""
                        )} / ${orderLineItem?.customfield4[0]?.value[0]?.replace(
                          regExpr,
                          ""
                        )}] ${orderLineItem?.productname[0]?.replace(
                          regExpr,
                          ""
                        )}</Descrip>
                    <Color>${orderLineItem.color[0]?.replace(
                      regExpr,
                      ""
                    )}</Color>
                    <Qty>${orderLineItem.qty[0]}</Qty>
                    <Size>${orderLineItem.customfield1[0]?.value[0]?.replace(
                      regExpr,
                      ""
                    )}</Size>
                    <Type>EMB</Type>
                    <Style>${orderLineItem?.productname[0].replace(
                      regExpr,
                      ""
                    )}</Style>
                    <ProcessMode>Piece</ProcessMode>
                    <Design>
                      <Location>${
                        orderLineItem?.customfield3[0]?.value[0] || "FRONT"
                      }</Location>
                      <Thumb>${orderLineItem?.quickpicthumblink[0]}</Thumb>
                      <SourceFile>${
                        orderLineItem?.imprintlogoartfile[0]
                      }</SourceFile>
                      <WhiteUnderbaseRequired>false</WhiteUnderbaseRequired>
                    </Design>`;
                      }

                      const xml = `<AddXml xmlns="http://tempuri.org/">
                    <OrderString>
                    <Request>
                        <CustID>1</CustID>
                        <PO>FICO-${orderId}</PO>
                        
                        <Source>Admin</Source>
                        <Store>Big Oven Tees</Store>
                        <StoreID>1</StoreID>
                        <ShipTo>
                            <FirstName>${data?.cart?.header[0]?.shippinginfo[0]?.name[0]?.replace(
                              regExpr,
                              ""
                            )}</FirstName>
                            <LastName></LastName>
                            <Company></Company>
                            <Adrx1>${data?.cart?.header[0]?.shippinginfo[0]?.address[0].replace(
                              regExpr,
                              ""
                            )}</Adrx1>
                            <Adrx2>${data?.cart?.header[0]?.shippinginfo[0]?.address2[0]?.replace(
                              regExpr,
                              ""
                            )}</Adrx2>
                            <City>${data?.cart?.header[0]?.shippinginfo[0]?.city[0]?.replace(
                              regExpr,
                              ""
                            )}</City>
                            
                            <State>${data?.cart?.header[0]?.shippinginfo[0]?.state[0]?.replace(
                              regExpr,
                              ""
                            )}</State>
                            <Zip>${data?.cart?.header[0]?.shippinginfo[0]?.zip[0].replace(
                              regExpr,
                              ""
                            )}</Zip>
                            <Country>${shippingCountry?.replace(
                              regExpr,
                              ""
                            )}</Country>
                            <Email></Email>
                        </ShipTo>
                        <ShipFrom>
                            <FirstName>Big Oven Tees</FirstName>
                            <LastName></LastName>
                            <Company>Big Oven Tees USA</Company>
                            <Adrx1>8742 Buffalo Avenue</Adrx1>
                            <Adrx2></Adrx2>
                            <City>Niagara Falls</City>
                            <State>NY</State>
                            <Zip>14304</Zip>
                            <Country>US</Country>
                            <Email>info@bigoventees.com</Email>
                          </ShipFrom>
                        <ShipMethod>FedEx (FedEx Ground)</ShipMethod>          
                        <ProductionPriority>Normal</ProductionPriority>
                        <Notes>SAGE ORDER ${orderId}</Notes>
                        ${items}                        
                    </Request>
                </OrderString>
              </AddXml>`;

                      await dispatch(submitOrderToUSA(xml, token));
                      onClose();
                    }}
                  />
                )}
            </RowFooter>
          </ModalBody>
          <ModalBody1>
            <ModalTitle>Notes</ModalTitle>

            <DatePicker
              label="Expected Ship Date"
              value={expectedShipDate}
              onChange={(v) => setShipDate(v)}
            />

            <textarea
              placeholder="Notes"
              value={notes}
              onChange={(e) => setNotes(e?.target?.value)}
              style={{ marginBottom: 10, width: "100%", marginTop: 10 }}
              rows={10}
            />
            <SubmitButton
              title="Submit"
              disabled={!expectedShipDate || !notes?.trim()}
              onClick={async () => {
                const payload = {
                  OrderNumber: data?.cart?.header[0]?.sessionid[0],
                  expectedShipDate:
                    moment(expectedShipDate).format("MMMM DD, YYYY"),
                  notes,
                  noteCreatedDate: moment().format("MMMM DD, YYYY"),
                };
                await dispatch(addNotes(payload));
                onClose();
              }}
            />

            <div style={{ marginTop: 10 }}>
              <ModalTitle>Prev Notes</ModalTitle>
              {data?.notes?.map((n) => (
                <div
                  style={{
                    backgroundColor: "#ccc",
                    color: "#000",
                    marginTop: 5,
                    borderRadius: 5,
                    padding: 15,
                    display: "flex",
                    position: "relative",
                  }}
                >
                  <div>{n?.notes}</div>
                  <div
                    style={{
                      position: "absolute",
                      right: 5,
                      bottom: 5,
                      fontSize: 10,
                    }}
                  >
                    {n?.noteCreatedDate}
                  </div>
                </div>
              ))}
            </div>
          </ModalBody1>
        </ModalWrapper>
      </DialogContent>
    </Dialog>
  );
};

export default OrbitkitModal;
